// 앱 뼈대 — 모든 화면 위에 머리말(서비스 이름 · 로그인 상태). 로그인 위젯은 auth 플러그인이 app.header 슬롯에 그린다
import { Link, Outlet } from 'react-router';

import { SlotHost } from './slot-host';

/** 서비스 이름 — 정식 이름이 정해지기 전 작업명 (DEC-95 컨셉 초안 「표시 이름 미정」) */
const SERVICE_NAME = 'AI 연재';

export function AppLayout() {
  return (
    // break-keep: 한글이 단어 중간에서 줄바꿈되지 않게 (휴대폰 폭에서 「연재하세/요」로 잘리던 것)
    <div className="min-h-dvh break-keep bg-serial-bg text-text-neutral-solid">
      <header className="sticky top-0 z-10 border-b border-serial-line bg-serial-bg/90 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-reading items-center justify-between px-4">
          <Link to="/" className="text-title-md">
            {SERVICE_NAME}
          </Link>
          <div className="flex items-center gap-2">
            <SlotHost slot="app.header" />
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-reading px-4 pb-16">
        <Outlet />
      </main>
      <aside className="mx-auto max-w-reading px-4">
        <SlotHost slot="home.aside" />
      </aside>
    </div>
  );
}
